import algoliasearch from "algoliasearch";
import { createNullCache } from "@algolia/cache-common";

export const client = algoliasearch(
  import.meta.env.VITE_ALGOLIA_APP_ID,
  import.meta.env.VITE_ALGOLIA_SEARCH_API_KEY,
  {
    responsesCache: createNullCache(),
  }
);

export const partsIndex = client.initIndex("parts");
